import { Outlet, useOutletContext } from '@remix-run/react'
import { P, styles } from '~/components-v2'
import { COPYRIGHT } from '~/config'
import style from './style.css?url'
import type { LinksFunction } from '@remix-run/node'
import { Header } from '~/components-v2/header/header'

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: style },
  // { rel: 'stylesheet', href: callout },
  { rel: 'stylesheet', href: styles.accordion },
  { rel: 'stylesheet', href: styles.stack },
]

// export const links = () => []

export default function () {
  const context = useOutletContext()

  return (
    <>
      <Header />
      <main className="main-scroll-area">
        <Outlet context={context} />
      </main>
      <footer>
        <P fontSize="xs" color="text2">
          {COPYRIGHT}
        </P>
      </footer>
    </>
  )
}
